import React from "react";
import Marquee from "react-fast-marquee";
const BrandAreaOne = () => {
  return (
    <div className='about-area  pt-5 pb-5'>
      <div className='container'>
        <div className='client-slider'>
          <Marquee gradient={false}>
            <div className='thumb brand_img'>
              <img src='https://seeklogo.com/images/A/association-touche-pas-a-mon-enfant-logo-74CAFABD91-seeklogo.com.png' alt='img' />
            </div>
            <div className='thumb brand_img'>
              <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBtbhb192z1-1GRh45nzgYUFRdURxvIRBkbCa7_yUWDQ&s' alt='img' />
            </div>
            <div className='thumb brand_img'>
              <img src='https://seeklogo.com/images/E/entraide-national-maroc-logo-7CB8B8E1DA-seeklogo.com.png' alt='img' />
            </div>
            <div className='thumb brand_img'>
              <img src='https://seeklogo.com/images/M/ministere-de-la-sante-et-de-la-protection-sociale-logo-BD47EE20E7-seeklogo.com.png' alt='img' />
            </div>
            <div className='thumb brand_img'>
              <img src='https://social.gov.ma/wp-content/uploads/2021/10/logo-MSISF-01-1-e1634812612684.png' alt='img' />
            </div>
            <div className='thumb brand_img'>
              <img src='https://upload.wikimedia.org/wikipedia/fr/0/0b/Men_2021.PNG' alt='img' />
            </div>
            <div className='thumb brand_img'>
              <img src='https://upload.wikimedia.org/wikipedia/commons/d/d3/MJ-Maroc.png' alt='img' />
            </div>
            <div className='thumb brand_img'>
              <img src='https://seeklogo.com/images/M/ministere-de-l-equipement-et-du-transport-maroc-logo-B80315F4F2-seeklogo.com.png' alt='img' />
            </div>
            <div className='thumb brand_img'>
              <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZfEr1hofYm1dnngu_KfpJAJM0tAMXDXwMGS32dEXwgQ&s' alt='img' />
            </div>    
          </Marquee>
        </div>
      </div>
    </div>
  );
};

export default BrandAreaOne;
